import { ModalProps as ModalPropsImport } from './Modal';

export { default } from './Modal';
export { default as ModalBodyPaper } from './ModalBodyPaper';
export type ModalProps = ModalPropsImport;
